import { defineMessages } from 'react-intl';

const messages = defineMessages({
  appHeadline: {
    id: '8joZWX',
    defaultMessage: 'Explore IBM Cloud products',
  },
  appSubhead: {
    id: '3plg7d',
    defaultMessage:
      'A full stack cloud platform with over 170 products and services covering data, containers, AI, IoT, and blockchain.',
  },
  appSubheadB: {
    id: 'bA3qoG',
    defaultMessage:
      'Use your existing infrastructure—even edge or other public clouds—with IBM Cloud services, APIs, access policies, security controls and compliance with ',
  },
  appSubheadBA: {
    id: 'OA2N2D',
    defaultMessage: 'Use ',
  },
  appSubheadBB: {
    id: '7cWwgR',
    defaultMessage:
      'to take Cloud anywhere: on premises, multicloud and to the Edge.',
  },
  appSubheadC: {
    id: 'JInslc',
    defaultMessage: 'IBM Cloud Satellite ',
  },
  appLearnMore: {
    id: 'TdTXXf',
    defaultMessage: 'Learn more',
  },
  aiName: {
    id: '1TonIP',
    defaultMessage: 'AI / machine learning',
  },
  aiDescription: {
    id: 'tvJ7wf',
    defaultMessage: 'Use Watson’s AI or build your own machine learning models',
  },
  watsonAssistantName: {
    id: 'H2B6zg',
    defaultMessage: 'IBM Watson Assistant',
  },
  watsonAssistantDescription: {
    id: 'ZNJrOS',
    defaultMessage: 'Virtual agents customizable to any domain',
  },
  watsonDiscoveryName: {
    id: 'qyzNY4',
    defaultMessage: 'IBM Watson Discovery',
  },
  watsonDiscoveryDescription: {
    id: 'njUA7c',
    defaultMessage: 'Search and analytics engine that adapts to custom domains',
  },
  watsonCatalogName: {
    id: 'vQF5Zs',
    defaultMessage: 'IBM Watson Knowledge Catalog',
  },
  watsonCatalogDescription: {
    id: 'qIvTZ4',
    defaultMessage: 'SaaS for AI data management',
  },
  watsonKnowledgeStudioName: {
    id: 'rlq8Fg',
    defaultMessage: 'IBM Watson Knowledge Studio',
  },
  watsonKnowledgeStudioDescription: {
    id: 'yaKewA',
    defaultMessage:
      'Visual interface to teach Watson domain-specific knowledge',
  },
  watsonLanguageTranslatorName: {
    id: 'ScFEs1',
    defaultMessage: 'IBM Watson Language Translator',
  },
  watsonLanguageTranslatorDescription: {
    id: 'y3M3RD',
    defaultMessage: 'API for translation with domain-specific models',
  },
  watsonLanguageClassifierName: {
    id: 'Udbq5C',
    defaultMessage: 'IBM Watson Natural Language Classifier',
  },
  watsonLanguageClassifierDescription: {
    id: 'nN08p2',
    defaultMessage: 'Visual tool and API for text classification',
  },
  watsonLanguageUnderstandingName: {
    id: 'ZZG8Oi',
    defaultMessage: 'IBM Watson Natural Language Understanding',
  },
  watsonLanguageUnderstandingDescription: {
    id: 'x/h7yL',
    defaultMessage: 'API for text analysis and metadata extraction',
  },
  watsonSpeechToTextName: {
    id: '04jLb9',
    defaultMessage: 'IBM Watson Speech to Text',
  },
  watsonSpeechToTextDescription: {
    id: 'LIuKA0',
    defaultMessage: 'API for real-time speech recognition and transcription',
  },
  watsonStudioName: {
    id: '7r2HpS',
    defaultMessage: 'IBM Watson Studio',
  },
  watsonStudioDescription: {
    id: 'SIrkDV',
    defaultMessage: 'IDE to build, run and manage AI models',
  },
  watsonTextToSpeechName: {
    id: 'g61N0j',
    defaultMessage: 'IBM Watson Text to Speech',
  },
  watsonTextToSpeechDescription: {
    id: 'YwEQe3',
    defaultMessage: 'API for real-time text to speech conversion',
  },
  analyticsName: {
    id: 'GZJpDf',
    defaultMessage: 'Analytics',
  },
  analyticsDescription: {
    id: 'qgPKkY',
    defaultMessage: 'Aggregate and analyze large datasets',
  },
  analyticsEngineName: {
    id: '3HMsx5',
    defaultMessage: 'IBM Analytics Engine',
  },
  analyticsEngineDescription: {
    id: '/xOV9k',
    defaultMessage:
      'PaaS to build analytics applications on Apache Spark and Hadoop ',
  },
  sqlQueryName: {
    id: 'Cpt0qn',
    defaultMessage: 'IBM Cloud Data Engine',
  },
  sqlQueryDescription: {
    id: 'IW8Ocm',
    defaultMessage:
      'Serverless, interactive querying service to analyze object storage data',
  },
  db2WarehouseName: {
    id: 'cqJU9h',
    defaultMessage: 'IBM Db2 Warehouse on Cloud',
  },
  db2WarehouseDescription: {
    id: 'rNUj2n',
    defaultMessage: 'Managed data warehouse on IBM Cloud or AWS',
  },
  infosphereName: {
    id: 'YYeR+/',
    defaultMessage: 'IBM InfoSphere® Information Server on Cloud',
  },
  infosphereDescription: {
    id: '0uWolc',
    defaultMessage: 'Data integration suite for ETL, governance and anlaysis',
  },
  mdmName: {
    id: 'hUqsVf',
    defaultMessage: 'IBM Master Data Management on Cloud',
  },
  mdmDescription: {
    id: 'CQilD5',
    defaultMessage: 'Managed master data storage',
  },
  streamingAnalyticsName: {
    id: 'pGC68e',
    defaultMessage: 'IBM Streaming Analytics',
  },
  streamingAnalyticsDescription: {
    id: '4MGh22',
    defaultMessage: 'Dashboard for real-time analysis of data streams',
  },
  automationName: {
    id: 'Fn4YKy',
    defaultMessage: 'Automation',
  },
  automationDescription: {
    id: 'U/Zosp',
    defaultMessage:
      'Automate workflows from IT operations to business processes',
  },
  cloudpakbaName: {
    id: 'hRPlIx',
    defaultMessage: 'IBM Cloud Pak for Business Automation',
  },
  cloudpakbaDescription: {
    id: 'Bjs0bd',
    defaultMessage: 'Operations management software with AI insights',
  },
  pakIntegrationName: {
    id: 'Mc9NMX',
    defaultMessage: 'IBM Cloud Pak for Integration',
  },
  pakIntegrationDescription: {
    id: 'muvaZX',
    defaultMessage:
      'An AI-powered integration software solution to connect your apps and data across any cloud.',
  },
  cloudpaknaName: {
    id: 'R1DO4B',
    defaultMessage: 'IBM Cloud Pak for Network Automation',
  },
  cloudpaknaDescription: {
    id: 'RfQ1sv',
    defaultMessage: 'Management software for telco network operations',
  },
  watsonAiopsName: {
    id: 'PAQ3PS',
    defaultMessage: 'IBM Cloud Pak for Watson AIOps',
  },
  watsonAiopsDescription: {
    id: 'WtlKy/',
    defaultMessage:
      'DevOps management tool with AI analysis and recommendations',
  },
  turbonomicName: {
    id: 'Os+JZk',
    defaultMessage: 'IBM Turbonomic® Application Resource Management',
  },
  turbonomicDescription: {
    id: 'vQzYxD',
    defaultMessage:
      'Software to automate application resource management and optimize costs',
  },
  blockchainName: {
    id: 'OkWAlI',
    defaultMessage: 'Blockchain',
  },
  blockchainDescription: {
    id: 'w3AaOs',
    defaultMessage: 'Build applications on an immutable blockchain ledger',
  },
  blockchainPlatformName: {
    id: 'CAhGT6',
    defaultMessage: 'IBM Blockchain Platform',
  },
  blockchainPlatformDescription: {
    id: 'fZYnzi',
    defaultMessage: 'Blockchain SDK based on Hyperledger Fabric',
  },
  computeName: {
    id: 'ab7TEe',
    defaultMessage: 'Compute',
  },
  computeDescription: {
    id: 'tF8wRJ',
    defaultMessage: 'Run workloads on cloud infrastrcture',
  },
  horizonName: {
    id: 'vPqMb0',
    defaultMessage: 'Dizzion Managed DaaS on IBM Cloud',
  },
  horizonDescription: {
    id: '/NWI1J',
    defaultMessage: 'Virtual desktops, in the cloud and managed',
  },
  bareMetalName: {
    id: 'w2FJX4',
    defaultMessage: 'IBM Cloud Bare Metal Servers',
  },
  bareMetalDescription: {
    id: '6H+967',
    defaultMessage: 'Dedicated hardware for maximum performance',
  },
  codeEngineName: {
    id: 'cecQ6e',
    defaultMessage: 'IBM Cloud Code Engine',
  },
  codeEngineDescription: {
    id: 'QXONVT',
    defaultMessage: 'Serverless container hosting platform as a service',
  },
  vmwareSolutionsName: {
    id: 'EkcUrj',
    defaultMessage: 'IBM Cloud for VMware Solutions',
  },
  vmwareSolutionsDescription: {
    id: '5DWH+i',
    defaultMessage: 'Hosting for virtualized workloads',
  },
  vpsHostingName: {
    id: '1PewX/',
    defaultMessage: 'IBM Cloud VPS Hosting',
  },
  vpsHostingDescription: {
    id: 'Zojq+P',
    defaultMessage: 'Easily manage fast-moving workloads.',
  },
  cloudFunctionsName: {
    id: 'Gz0Q3f',
    defaultMessage: 'IBM Cloud Functions',
  },
  cloudFunctionsDescription: {
    id: 'Cke3Eg',
    defaultMessage: 'Serverless function runtime based on Apache OpenWhisk',
  },
  vpcName: {
    id: 'QIXig5',
    defaultMessage: 'IBM Cloud Virtual Server for VPC',
  },
  vpcDescription: {
    id: '71QhXK',
    defaultMessage: 'Virtual servers with enhanced network security',
  },
  virtualServersName: {
    id: '++WyHu',
    defaultMessage: 'IBM Cloud Virtual Servers for Classic Infrastructure',
  },
  virtualServersDescription: {
    id: 'c5ozcM',
    defaultMessage:
      'Virtual servers with the most flexible configuration options',
  },
  hyperProtectVirtualServersName: {
    id: 'vfoXSK',
    defaultMessage: 'IBM Hyper Protect Virtual Servers',
  },
  hyperProtectVirtualServersDescription: {
    id: 'nmblXM',
    defaultMessage: 'Virtual servers for workloads with sensitive data',
  },
  powerVirtualServerName: {
    id: '5ftS+u',
    defaultMessage: 'IBM Power Systems Virtual Servers',
  },
  powerVirtualServerDescription: {
    id: 'OvH4dR',
    defaultMessage: 'Virtual servers with IBM POWER processors',
  },
  websphereName: {
    id: 'LRDydZ',
    defaultMessage: 'IBM WebSphere Application Server on Cloud',
  },
  websphereDescription: {
    id: 'DXendR',
    defaultMessage: 'Runtime and SDK for Java applications',
  },
  containersName: {
    id: 'TDDlIs',
    defaultMessage: 'Containers',
  },
  containersDescription: {
    id: 'u9zWS+',
    defaultMessage: 'Deploy applications consistently across environments',
  },
  containerRegistryName: {
    id: 'A5T/sB',
    defaultMessage: 'Container registry',
  },
  containerRegistryDescription: {
    id: 'fyaRux',
    defaultMessage: 'SaaS for container storage and management',
  },
  kubernetesName: {
    id: '0UBJ54',
    defaultMessage: 'IBM Cloud Kubernetes Service',
  },
  kubernetesDescription: {
    id: 'WBSGau',
    defaultMessage:
      'Container hosting with self-healing and horizontal scaling',
  },
  istioName: {
    id: 'WhpOBd',
    defaultMessage: 'Istio',
  },
  istioDescription: {
    id: 'pIUXrB',
    defaultMessage: 'A service mesh for microservices in Kubernetes clusters',
  },
  openShiftName: {
    id: 'iy++Ui',
    defaultMessage: 'Red Hat® OpenShift® on IBM Cloud',
  },
  openShiftDescription: {
    id: 'mpm2U2',
    defaultMessage: 'Container hosting on managed Red Hat Linux servers',
  },
  databasesName: {
    id: 'RYbE1p',
    defaultMessage: 'Databases',
  },
  databasesDescription: {
    id: 'SAgOYa',
    defaultMessage: 'Store, query and analyze structured data',
  },
  databasesForElasticsearchName: {
    id: 'bw4KmR',
    defaultMessage: 'IBM Cloud Databases for Elasticsearch',
  },
  databasesForElasticsearchDescription: {
    id: 'yC3Bny',
    defaultMessage: 'Managed JSON document store for full-text search',
  },
  databasesForEnterprisedbName: {
    id: 'dmETcB',
    defaultMessage: 'IBM Cloud Databases for EnterpriseDB',
  },
  databasesForEnterprisedbDescription: {
    id: '7E1J9z',
    defaultMessage: 'Managed SQL database',
  },
  databasesForEtcdName: {
    id: 'TleofT',
    defaultMessage: 'IBM Cloud Databases for etcd',
  },
  databasesForEtcdDescription: {
    id: '3oH2rw',
    defaultMessage: 'Managed distributed key-value store',
  },
  databasesForMongodbName: {
    id: 'YLUpsk',
    defaultMessage: 'IBM Cloud Databases for MongoDB',
  },
  databasesForMongodbDescription: {
    id: 'mXhQDU',
    defaultMessage: 'Managed NoSQL JSON document store',
  },
  databasesForMysqlName: {
    id: 'yPSXlW',
    defaultMessage: 'IBM Cloud Databases for MySQL',
  },
  databasesForMysqlDescription: {
    id: 'QVh/NP',
    defaultMessage:
      'A fully managed MySQL relational database service. Deploy and scale effortlessly to drive innovation.',
  },
  databasesForPostgresqlName: {
    id: 'iEOCYm',
    defaultMessage: 'IBM Cloud Databases for PostgreSQL',
  },
  databasesForPostgresqlDescription: {
    id: '7E1J9z',
    defaultMessage: 'Managed SQL database',
  },
  databasesForRedisName: {
    id: 'ABMG1N',
    defaultMessage: 'IBM Cloud Databases for Redis',
  },
  databasesForRedisDescription: {
    id: 'xWOoBo',
    defaultMessage: 'Managed in-memory key value store',
  },
  cloudantName: {
    id: '7mrMpv',
    defaultMessage: 'IBM Cloudant®',
  },
  cloudantDescription: {
    id: '4t44vN',
    defaultMessage: 'Managed PCI-compliant JSON document store on CouchDB',
  },
  db2Name: {
    id: 'QiEOvL',
    defaultMessage: 'IBM Db2® on Cloud',
  },
  db2Description: {
    id: '7E1J9z',
    defaultMessage: 'Managed SQL database',
  },
  hyperProtectDbaasName: {
    id: 'RsuUiH',
    defaultMessage: 'IBM Hyper Protect DBaaS',
  },
  hyperProtectDbaasDescription: {
    id: 'R/fawH',
    defaultMessage: 'Managed PostgreSQL and MongoDB for sensitive data',
  },
  informixName: {
    id: 'xklCtM',
    defaultMessage: 'IBM Informix® on Cloud',
  },
  informixDescription: {
    id: 'TvkU5U',
    defaultMessage: 'Managed DB for time series, spatial, NoSQL and SQL data',
  },
  developerToolsName: {
    id: 'g/w+Mb',
    defaultMessage: 'Developer tools',
  },
  developerToolsDescription: {
    id: 'a2I/+Q',
    defaultMessage: 'Manage infrastructure, environments and deployments',
  },
  appConfigurationName: {
    id: '+9vdTn',
    defaultMessage: 'IBM Cloud App Configuration',
  },
  appConfigurationDescription: {
    id: 'VrOy6P',
    defaultMessage: 'SDK, dashboard and API for application feature management',
  },
  cloudCliName: {
    id: '4TUmUg',
    defaultMessage: 'IBM Cloud CLI',
  },
  cloudCliDescription: {
    id: '8C8NDW',
    defaultMessage: 'A CLI to manage your IBM Cloud',
  },
  continuousDeliveryName: {
    id: 'd0J9+U',
    defaultMessage: 'IBM Cloud Continuous Delivery',
  },
  continuousDeliveryDescription: {
    id: 'KqvGDN',
    defaultMessage:
      'UI and CLI based DevOps workflows based on Tekton Pipelines',
  },
  messagesForRabbitmqName: {
    id: 'C8DVFE',
    defaultMessage: 'IBM Cloud Messages for RabbitMQ',
  },
  messagesForRabbitmqDescription: {
    id: 'p33z2x',
    defaultMessage: 'Managed message broker',
  },
  schematicsName: {
    id: '5rIK92',
    defaultMessage: 'IBM Cloud Schematics',
  },
  schematicsDescription: {
    id: 'O7DLNZ',
    defaultMessage:
      'Managed service to provision resources with terraform templates',
  },
  tektonName: {
    id: '8pvAuZ',
    defaultMessage: 'Tekton',
  },
  tektonDescription: {
    id: 'mzfhv8',
    defaultMessage: 'Kubernetes-native CI and CD pipelines',
  },
  ibmCloudPaksName: {
    id: 'SgxPaA',
    defaultMessage: 'IBM Cloud Paks',
  },
  ibmCloudPaksDescription: {
    id: '9L6a1L',
    defaultMessage:
      'Integrated and certified applications on Red Hat OpenShift',
  },
  pakDataName: {
    id: 'LavEEz',
    defaultMessage: 'IBM Cloud Pak for Data',
  },
  pakDataDescription: {
    id: 'YQrc3L',
    defaultMessage: 'Tools for data analysis, organization and management',
  },
  pakSecurityName: {
    id: 'v+D0LH',
    defaultMessage: 'IBM Cloud Pak for Security',
  },
  pakSecurityDescription: {
    id: 'JCGVvu',
    defaultMessage: 'Security auditing, reporting, analysis and governance',
  },
  integrationName: {
    id: 'bx7Ou/',
    defaultMessage: 'Integration',
  },
  integrationDescription: {
    id: '8ytOBq',
    defaultMessage:
      'Integrate your apps through APIs, messaging and networking tools',
  },
  apiConnectName: {
    id: 'qNKPiq',
    defaultMessage: 'IBM API Connect®',
  },
  apiConnectDescription: {
    id: 'QG19qO',
    defaultMessage: 'A toolkit to rapidly create, secure and manage APIs',
  },
  appConnectName: {
    id: 'XELYQp',
    defaultMessage: 'IBM App Connect',
  },
  appConnectDescription: {
    id: '4bbD8a',
    defaultMessage: 'Codeless connectors for your data, apps and APIs',
  },
  asperaName: {
    id: 'viCUfU',
    defaultMessage: 'IBM Aspera® on Cloud',
  },
  asperaDescription: {
    id: 'bRDwJk',
    defaultMessage: 'UI and CLI to rapidly move large files',
  },
  skytapName: {
    id: 'hFnvg2',
    defaultMessage: 'IBM Cloud for Skytap Solutions',
  },
  skytapDescription: {
    id: 'CU1tuU',
    defaultMessage:
      'Virtualization for x86, AIX, System i and Power applications',
  },
  eventStreamsName: {
    id: 'ioUkiO',
    defaultMessage: 'IBM Event Streams',
  },
  eventStreamsDescription: {
    id: '7xSb+w',
    defaultMessage: 'PaaS stream processing based on Apache Kafka',
  },
  liftName: {
    id: 'HiuEPq',
    defaultMessage: 'IBM Lift',
  },
  liftDescription: {
    id: '1scQvB',
    defaultMessage: 'Toolkit to migrate on-premises data to the cloud',
  },
  cloudMqName: {
    id: 'fn+qTy',
    defaultMessage: 'IBM MQ on Cloud',
  },
  cloudMqDescription: {
    id: 'p33z2x',
    defaultMessage: 'Managed message broker',
  },
  secureGatewayName: {
    id: '/H9IZy',
    defaultMessage: 'Secure gateway',
  },
  secureGatewayDescription: {
    id: 'Xj6Wse',
    defaultMessage: 'Secure tunnels between cloud and external environments',
  },
  iotName: {
    id: 'v9mtsp',
    defaultMessage: 'Internet of things',
  },
  iotDescription: {
    id: 'NqlVin',
    defaultMessage: 'Connect and manage edge devices',
  },
  edgeComputingName: {
    id: 'S8NAfT',
    defaultMessage: 'IBM Edge Application Manager',
  },
  edgeComputingDescription: {
    id: 'j/GhH0',
    defaultMessage: 'An autonomous management platform for edge computing',
  },
  iotPlatformName: {
    id: '9p/LP6',
    defaultMessage: 'IBM Maximo Application Suite: Remote monitoring',
  },
  iotPlatformDescription: {
    id: 'EI6gkl',
    defaultMessage:
      'See, predict and prevent issues with advanced AI-powered remote monitoring and computer vision for assets and operations.',
  },
  loggingAndMonitoringName: {
    id: '7qnDjd',
    defaultMessage: 'Logging and monitoring',
  },
  loggingAndMonitoringDescription: {
    id: 'siBewP',
    defaultMessage: 'Log and analyze activity in your infrastructure',
  },
  activityTrackerName: {
    id: '1ioGP+',
    defaultMessage: 'IBM Cloud Activity Tracker',
  },
  activityTrackerDescription: {
    id: '4aKykC',
    defaultMessage: 'Dashboard to monitor and analyze events in IBM Cloud',
  },
  logAnalysisName: {
    id: '/ViV2M',
    defaultMessage: 'IBM Cloud Log Analysis',
  },
  logAnalysisDescription: {
    id: 'uzKLXd',
    defaultMessage: 'Analysis dashboard for system and application logs',
  },
  sysdigName: {
    id: '/Fo9fO',
    defaultMessage: 'IBM Cloud Monitoring',
  },
  sysdigDescription: {
    id: 'DmNdXe',
    defaultMessage: 'Managed dashboard for Kubernetes devops',
  },
  networkName: {
    id: '8wm6f9',
    defaultMessage: 'Networking',
  },
  networkDescription: {
    id: 'o5DTVG',
    defaultMessage: 'Run and manage public, private and virtual networks',
  },
  dnsName: {
    id: 'YZGl5T',
    defaultMessage: 'Domain name services',
  },
  dnsDescription: {
    id: 'adJBTQ',
    defaultMessage: 'Public and private DNS and domain registration',
  },
  cdnName: {
    id: 'pAspmM',
    defaultMessage: 'IBM Cloud Content Delivery Network',
  },
  cdnDescription: {
    id: 'b9HZtl',
    defaultMessage: 'Content caching and delivery on the Akamai network',
  },
  directLinkName: {
    id: 'wKdz2h',
    defaultMessage: 'IBM Cloud Direct Link',
  },
  directLinkDescription: {
    id: 'Ayup/o',
    defaultMessage: 'Physical or virtual private connections to IBM Cloud',
  },
  cloudInternetServicesName: {
    id: 'vEECcp',
    defaultMessage: 'IBM Cloud Internet Services',
  },
  cloudInternetServicesDescription: {
    id: 'U8MRda',
    defaultMessage: 'Load balancing and CDN solution',
  },
  loadBalancerName: {
    id: 'pLaX4V',
    defaultMessage: 'Load balancer',
  },
  loadBalancerDescription: {
    id: 'Bu3YcZ',
    defaultMessage: 'Traffic flow management for cloud applications',
  },
  networkAppliancesName: {
    id: 'askI7n',
    defaultMessage: 'Network appliances',
  },
  networkAppliancesDescription: {
    id: 'MojMtC',
    defaultMessage: 'Physical and virtual routers, firewalls, VPNs and more',
  },
  loudNetworkSecurityName: {
    id: 'O9FD6C',
    defaultMessage: 'Network security',
  },
  loudNetworkSecurityDescription: {
    id: '8yy81e',
    defaultMessage:
      'Hardware and software firewalls, network security group management',
  },
  quantumName: {
    id: 'i956Rq',
    defaultMessage: 'Quantum',
  },
  quantumDescription: {
    id: 'VQUAYA',
    defaultMessage: 'Run code on real quantum systems using a full-stack SDK',
  },
  qiskitName: {
    id: 'IKkrDs',
    defaultMessage: 'Qiskit',
  },
  qiskitDescription: {
    id: '6+Wt0y',
    defaultMessage: 'Python SDK for open-source quantum development',
  },
  qiskitRuntimeName: {
    id: 'Cj9muP',
    defaultMessage: 'Qiskit Runtime',
  },
  qiskitRuntimeDescription: {
    id: 'sk3srD',
    defaultMessage: 'Low-latency execution environment for quantum programs',
  },
  securityName: {
    id: 'Py189G',
    defaultMessage: 'Security',
  },
  securityDescription: {
    id: 'X28+9+',
    defaultMessage:
      'Secure your cloud resources and simplify regulatory compliance',
  },
  appIdName: {
    id: '1Oh28L',
    defaultMessage: 'IBM Cloud App ID',
  },
  appIdDescription: {
    id: 'G8baz3',
    defaultMessage:
      'Compliant authentication, authorization and user data SaaS',
  },
  securityModuleName: {
    id: 'NuD+6l',
    defaultMessage: 'IBM Cloud Hardware Security Module',
  },
  securityModuleDescription: {
    id: 'hmsbqG',
    defaultMessage:
      'Tamper-resistant hardware to store and process cryptographic keys',
  },
  secretsManagerName: {
    id: 'xyfSnR',
    defaultMessage: 'IBM Cloud Secrets Manager',
  },
  secretsManagerDescription: {
    id: 'y/JVM1',
    defaultMessage: 'Single-tenant, dedicated instance to manage your secrets',
  },
  securityAdvisorName: {
    id: 'glP6MT',
    defaultMessage: 'IBM Cloud Security Advisor',
  },
  securityAdvisorDescription: {
    id: 'U0mQyT',
    defaultMessage:
      'Dashboard for security management, analysis and remediation',
  },
  compianceCenterName: {
    id: '+6DSL9',
    defaultMessage: 'IBM Cloud Security and Compliance Center',
  },
  compianceCenterDescription: {
    id: '8tEeK+',
    defaultMessage:
      'SaaS to define and audit the compliance posture of your cloud',
  },
  hyperProtectCryptoServicesName: {
    id: 'O4gNbU',
    defaultMessage: 'IBM Hyper Protect Crypto Services',
  },
  hyperProtectCryptoServicesDescription: {
    id: '0BsYsn',
    defaultMessage: 'Cloud hardware to store and process cryptographic keys',
  },
  keyProtectName: {
    id: 'fSHGyF',
    defaultMessage: 'IBM Key Protect',
  },
  keyProtectDescription: {
    id: 'Irwwbi',
    defaultMessage:
      'Encryption key provisioning and storage for IBM Cloud apps',
  },
  sslCertificatesName: {
    id: 'YhthEh',
    defaultMessage: 'SSL certificates',
  },
  sslCertificatesDescription: {
    id: '4kPVn5',
    defaultMessage: 'Certificates for cloud resources',
  },
  storageName: {
    id: 'DUIDEq',
    defaultMessage: 'Storage',
  },
  storageDescription: {
    id: 'xS4ray',
    defaultMessage: 'Store, migrate and back up your data',
  },
  backupName: {
    id: 'oSZCMT',
    defaultMessage: 'IBM Cloud Backup',
  },
  backupDescription: {
    id: '+WAYgA',
    defaultMessage:
      'Fully encrypted backup and recovery across multiple datacenters ',
  },
  blockStorageName: {
    id: 'aOPlYn',
    defaultMessage: 'IBM Cloud Block Storage',
  },
  blockStorageDescription: {
    id: 'N3uAdR',
    defaultMessage:
      'The lowest latency, highest redundancy data storage option',
  },
  fileStorageName: {
    id: 'M6gSgN',
    defaultMessage: 'IBM Cloud File Storage',
  },
  fileStorageDescription: {
    id: '0vyqQ5',
    defaultMessage:
      'The simplest solution for data organized into files and folders',
  },
  massDataMigrationName: {
    id: 'EXrelJ',
    defaultMessage: 'IBM Cloud Mass Data Migration',
  },
  massDataMigrationDescription: {
    id: 'Mdm8ji',
    defaultMessage:
      'Secure hardware to physically ship petabytes of data to IBM Cloud',
  },
  objectStorageName: {
    id: 'L191bn',
    defaultMessage: 'IBM Cloud Object Storage',
  },
  objectStorageDescription: {
    id: 'XzhFjl',
    defaultMessage: 'Unstructured cloud data storage with an API frontend',
  },
});

export default messages;
